import { appEnvironmentActionTypes } from '@actions/actionTypes/appEnvironment';
import { appEnvironmentInitialState } from './initialState/appEnvironment';
import { AnyAction } from 'redux';


export const appEnvironmentReducer = (state = appEnvironmentInitialState, action: AnyAction) => {
  switch (action.type) {
    case appEnvironmentActionTypes.SET_CONFIG_VARIABLES: {
      return { ...state, configVariables: action.payload };
    }
    default: {
      return state;
    }
  }
};
